import { PortableText as BasePortableText } from '@portabletext/react';
import React from 'react';
import clientConfig from '../../../client-config';
import { replaceAnchorTag } from '../../cms/helpers/link-with-tracking';
import { portableTextWrappers } from './elements';

type PortableTextProps = {
  href?: string;
  blocks: Record<string, any>;
};

// @ts-ignore
const PortableText = ({ href, blocks }: PortableTextProps) => (
  <BasePortableText
    value={blocks}
    components={{
      types: {
        /* eslint-disable-next-line react/display-name */
        authorReference: ({ node }: any) => <span>{node?.author?.name}</span>,
        mainImage: portableTextWrappers.img,
        table: ({ value }) => portableTextWrappers.table({ value, href })
      },
      block: {
        h1: ({ children }) => portableTextWrappers.h1(children),
        h2: ({ children }) => portableTextWrappers.h2(children),
        h3: ({ children }) => portableTextWrappers.h3(children),
        p: ({ children }) => portableTextWrappers.p(children)
      },
      marks: {
        link: ({ value, children }) => replaceAnchorTag(value, children),
        internalLink: ({ value, children }) => replaceAnchorTag(value, children),
        strong: ({ value, children }) => portableTextWrappers.strong({}, children)
      }
    }}
    {...clientConfig.sanity}
  />
);

export default PortableText;
